import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../core/signals.mjs';
import {
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
} from '../../core/ReactiveState.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../core/ReactiveMutableList.mjs';
import { listOfNotNull1v4ggfackvuny as listOfNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../core/Remember.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var IssueClass;
function Issue() {
  if (IssueClass === VOID) {
    class $ {
      constructor(summary, description, setValue) {
        description = description === VOID ? summary : description;
        setValue = setValue === VOID ? true : setValue;
        this.summary_1 = summary;
        this.description_1 = description;
        this.setValue_1 = setValue;
      }
      toString() {
        return 'Issue(summary=' + this.summary_1 + ', description=' + this.description_1 + ', setValue=' + this.setValue_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.summary_1);
        result = imul(result, 31) + getStringHashCode(this.description_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.setValue_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Issue()))
          return false;
        if (!(this.summary_1 === other.summary_1))
          return false;
        if (!(this.description_1 === other.description_1))
          return false;
        if (!(this.setValue_1 === other.setValue_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Issue');
    IssueClass = $;
  }
  return IssueClass;
}
function IssueNode$disconnect$ref(p0) {
  return constructCallableReference(() => {
    p0.disconnect_t9cc0c_k$();
    return Unit_instance;
  }, 0, 0, 10, 'disconnect', [p0]);
}
var IssueNodeClass;
function IssueNode() {
  if (IssueNodeClass === VOID) {
    class $ {
      constructor(parent) {
        parent = parent === VOID ? null : parent;
        this.parent_1 = parent;
        this.nodeIssue_1 = RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$(this.parent_1 == null ? _ReactiveState___init__impl__fvdp9b(null) : Companion_getInstance().notActive_1);
        this.children_1 = ReactiveMutableList().new_com_lightningkite_reactive_core_ReactiveMutableList_tgiub6_k$();
        this.connected_1 = this.parent_1 == null;
        this.saveState_1 = _ReactiveState___init__impl__fvdp9b(null);
        var tmp = this;
        tmp.issues_1 = remember(VOID, VOID, VOID, 100, ($this$remember) => {
          var tmp = listOfNotNull($this$remember.invoke_r7m7el_k$(this.nodeIssue_1));
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = $this$remember.invoke_r7m7el_k$(this.children_1);
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var list = $this$remember.invoke_r7m7el_k$(element.issues_1);
            addAll(destination, list);
          }
          return plus(tmp, destination);
        });
      }
      reportRaw_ihpspr_k$(issue) {
        this.nodeIssue_1.set_state_wnfcx0_k$(issue);
      }
      report_ins8zt_k$(issue) {
        this.nodeIssue_1.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b(issue));
      }
      child_v2u7ef_k$(connect) {
        // Inline function 'kotlin.also' call
        var this_0 = new (IssueNode())(this);
        if (connect) {
          this_0.connect_ivqcka_k$();
        }
        return this_0;
      }
      child$default_s9je3b_k$(connect, $super) {
        connect = connect === VOID ? true : connect;
        return $super === VOID ? this.child_v2u7ef_k$(connect) : $super.child_v2u7ef_k$.call(this, connect);
      }
      connect_ivqcka_k$() {
        if (this.connected_1 || this.parent_1 == null)
          return Unit_instance;
        this.connected_1 = true;
        this.nodeIssue_1.set_state_wnfcx0_k$(this.saveState_1);
        this.parent_1.children_1.add_wl2rvy_k$(this);
      }
      disconnect_t9cc0c_k$() {
        if (!this.connected_1 || this.parent_1 == null)
          return Unit_instance;
        this.connected_1 = false;
        this.saveState_1 = this.nodeIssue_1.get_state_wc71uu_k$();
        this.nodeIssue_1.set_state_wnfcx0_k$(Companion_getInstance().notActive_1);
        this.parent_1.children_1.remove_an8aut_k$(this);
      }
      beginUse_omrbby_k$() {
        this.connect_ivqcka_k$();
        return IssueNode$disconnect$ref(this);
      }
    }
    initMetadataForClass($, 'IssueNode', IssueNode);
    IssueNodeClass = $;
  }
  return IssueNodeClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  IssueNode as IssueNode2x8c6ia7dmfdz,
  Issue as Issuef8rh7nn7wz0o,
};
//endregion

//# sourceMappingURL=IssueNode.mjs.map
